<template>
  <section>
    <form method="post" @submit.prevent="onSend" novalidate>
      <div class="modal-card" style="width: 850px;">
        <header class="modal-card-head">
          <p class="modal-card-title is-centered">{{ formTitle }}</p>
        </header>
        <section class="modal-card-body">
          <form-wrapper :validator="$v.form" :loading="sending">
            <form-group
              name="name"
              horizontal
              :label="$t('attributes.company')"
              label-position="on-border"
            >
              <b-input
                v-model="form.name"
                type="text"
                expanded
                @input="onCompanyNameAccountNameSync"
              />
            </form-group>
            <form-group
              name="business_number"
              horizontal
              :label="$t('attributes.business_number')"
              label-position="on-border"
            >
              <b-input
                v-if="mode === 'create'"
                v-model="form.business_number"
                type="text"
                expanded
              />
              <span v-else>{{ form.business_number }}</span>
            </form-group>
            <form-group
              name="bank"
              horizontal
              label="銀行庫局"
              label-position="on-border"
            >
              <b-select
                v-model="selectedBank"
                name="banks"
                placeholder="請選擇銀行庫局"
                expanded
                @input="onBankSelected"
              >
                <option value="">請選擇銀行</option>
                <option
                  v-for="option in banks"
                  :value="option"
                  :key="option.bank_number"
                >
                  [{{ option.bank_number }}]{{ option.bank_name }}
                </option>
              </b-select>
            </form-group>
            <form-group
              name="branch_name"
              horizontal
              label="分行支庫局"
              label-position="on-border"
            >
              <b-input v-model="form.branch_name" type="text" expanded />
            </form-group>
            <form-group
              name="account_name"
              horizontal
              :label="$t('attributes.account_name')"
              label-position="on-border"
            >
              <b-input v-model="form.account_name" type="text" expanded />
            </form-group>
            <form-group
              name="account_number"
              horizontal
              :label="$t('attributes.account_number')"
              label-position="on-border"
            >
              <b-input v-model="form.account_number" type="text" expanded />
            </form-group>
          </form-wrapper>
        </section>
        <footer class="modal-card-foot">
          <b-button
            :loading="sending"
            class="is-fullwidth"
            @click="$parent.close()"
          >
            {{ $t('attributes.close') }}
          </b-button>
          <b-button
            :loading="sending"
            type="is-primary"
            class="is-fullwidth"
            native-type="submit"
          >
            {{
              mode === 'create'
                ? $t('attributes.add')
                : $t('attributes.update_data')
            }}
          </b-button>
        </footer>
      </div>
    </form>
  </section>
</template>
<script>
import { maxLength, required } from 'vuelidate/lib/validators'
import { BUSINESS_ENTITY_API } from '@/utils/apis'
import notifyService from '@/services/notifyService'

export default {
  name: 'BusinessEntityDetail',
  props: {
    data: {
      type: Object,
      required: true
    },
    mode: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      formTitle: this.mode === 'create' ? '新增廠商' : '修改廠商',
      sending: false,
      loading: false,

      banks: [],
      selectedBank: null,

      form: this.extractFormValues(this.data)
    }
  },
  validations: {
    form: {
      id: {},
      name: { required, maxLength: maxLength(100) },
      business_number: { required, maxLength: maxLength(15) },
      bank_number: { required },
      bank_name: {},
      branch_name: { required },
      account_number: { required, maxLength: maxLength(50) },
      account_name: { required, maxLength: maxLength(50) }
    }
  },
  mounted() {
    this.loadBanks()
  },
  methods: {
    async loadBanks() {
      try {
        const api = `${BUSINESS_ENTITY_API}/banks/list`

        this.loading = true
        const res = await this.axios.get(api)
        this.banks = res.data.data

        this.selectedBank = null
        if (this.form.bank_number) {
          this.selectedBank = this.banks.find(
            a => a.bank_number === this.form.bank_number
          )
        }
      } catch (e) {
        this.selectedItem = null
        this.banks = []
        notifyService.fetch_error('bank', e)
      } finally {
        this.loading = false
      }
    },
    extractFormValues(data) {
      return {
        id: data.id,
        name: data.name,
        business_number: data.business_number,
        bank_name: data.bank_name,
        bank_number: data.bank_number,
        branch_name: data.branch_name,
        account_number: data.account_number,
        account_name: data.account_name
      }
    },
    onBankSelected(item) {
      this.selectedBank = item
      this.form.bank_name = item.bank_name
      this.form.bank_number = item.bank_number
    },
    onCompanyNameAccountNameSync() {
      if (this.form.account_name === '') {
        this.form.account_name = this.form.name
      }
    },
    async onSend() {
      this.$v.$touch()

      if (this.$v.$invalid) {
        return
      }

      this.form.account_number = this.form.account_number.trim()
      this.form.account_name = this.form.account_name.trim()
      this.form.name = this.form.name.trim()
      this.form.business_number = this.form.business_number.trim()
      this.$emit('send', this.form)
    }
  }
}
</script>
